<template>
    <div class="table-responsive">
    <base-table :key="'table'+tick" class="table align-items-center table-flush table-bg"
                thead-classes="thead-light bg-white"
                tbody-classes="list"
                :data="taskTemplates">
        <template slot="columns">
            <th>Name</th>
            <th>Zeitplan</th>
            <th>Öffentlich</th>
            <th>AutoComplete</th>
            <th>Aktiv</th>
            <th></th>
        </template>
        <template slot-scope="{row}">
            <th v-if="isLoadingTemplates" scope="row" >
                <div class="loading"> </div>
            </th>
            <th v-else scope="row" v-html="row.type">
            </th>
            <td v-if="isLoadingTemplates" scope="row" >
                <div class="loading"> </div>
            </td>
            <td v-else scope="row" style="white-space: normal !important;" v-html="getHumanReadableString(row.schedule)">
            </td>
            <td v-if="isLoadingTemplates" scope="row" >
                <div class="loading"> </div>
            </td>
            <td v-else scope="row"><i class="fas fa-circle" :alt="row.isPublic" :class="row.isPublic ? 'text-success' : 'text-danger'"></i>
            </td>
            <td v-if="isLoadingTemplates" scope="row" >
                <div class="loading"> </div>
            </td>
            <td v-else scope="row"><i class="fas fa-circle" :alt="row.isAutocomplete" :class="row.isAutocomplete ? 'text-success' : 'text-danger'"></i>
            </td>
            <td v-if="isLoadingTemplates" scope="row" >
                <div class="loading"> </div>
            </td>
            <td v-else scope="row"><i class="fas fa-circle" :alt="row.isActive" :class="row.isActive ? 'text-success' : 'text-danger'"></i>
            </td>
            <td :key="tick">
                <div v-if="isLoadingTemplates" class="loading-button"> </div><div v-else>
                <base-button  type="primary" icon="fas fa-pencil-alt" v-on:click="editTaskTemplate(row)"></base-button>
            </div>
            </td>
        </template>
    </base-table>
        <task-template-modal ref="tasktemplatemodal" :location="location" :show="showTaskTemplateModal" @modalClosed="refreshData"></task-template-modal>
    </div>
</template>

<script>
    import cronstrue from 'cronstrue/i18n';
    import TaskTemplateModal from "@/views/TaskTemplates/TaskTemplateModal";
    export default {
        name:"list",
        components:{TaskTemplateModal},
        props: {
            location: {
                type: String
            }
        },
        data() {
            return {
                taskTemplates: [
                    {
                        description:null,
                        schedule:'0 8-23/2 * * *',
                        isPublic:false,
                        possibleAnswers:[],
                        location:null,
                        type:'',
                        user:null,
                        isActive:true,
                        isAutocomplete:false
                    }
                ],
                isLoadingTemplates: true,
                showTaskTemplateModal: {value: false},
                tick: 1
            }
        },
        created() {
            this.refreshData();
        },
        methods: {
            refreshData() {
                this.isLoadingTemplates = true;
                this.tick++
                this.getTaskTemplates(this.location).then(response => {
                    this.taskTemplates = response.member;
                    this.isLoadingTemplates = false;
                    this.tick++
                }).catch(error => {
                    this.$store.dispatch('alert/error',error);
                    this.isLoadingTemplates = false;
                    this.tick++
                })
            },
            getTaskTemplates(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/task_templates?location=`+id+`&pagination=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve({
                                    totalItems: response['hydra:totalItems'],
                                    member: response['hydra:member']
                                });

                            },
                            error => {
                                reject(error);
                            });
                });
            },
            getHumanReadableString(exp) {
                return cronstrue.toString(exp,{locale: 'de'});
            },
            editTaskTemplate(obj){
                this.showTaskTemplateModal.value = true;
                this.$refs.tasktemplatemodal.$refs.tasktemplateform.form = JSON.parse(JSON.stringify(obj));
                this.$refs.tasktemplatemodal.$refs.tasktemplateform.form.user = (typeof obj.user !== 'undefined') ? obj.user['@id'] : null;
                this.$refs.tasktemplatemodal.$refs.tasktemplateform.form.location = (typeof obj.location !== 'undefined') ? obj.location['@id'] : null ;
            }
        }
    }
</script>

<style scoped>

    .table-bg {
        background-color: #ffffff;
    }

</style>